<!-- loader.component.html -->
@if(appStateService.apiLoading$| async) {
<div class="overlay request-loading-indicator">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>
}
